import { useRef, useState } from "react";
import { InputRef, Modal } from "antd";
import { TopBar } from "../../../../../widgets";
import NickNameCreateAndUpdateInput from "../nickNameCreateAndUpdateInput";

interface IProps {
    propsRefetch?: Function
    open: boolean
    setOpen: Function
    title?: string
    leftIcon?: 'back' | 'none';
    isShowSaveBtn?: boolean
    saveBtntext?: string;
    description?: string;
    classNames?: { description?: string, saveBtn?: string }
}

const NickNameCreateAndUpdateModal = ({ propsRefetch, open, setOpen, title = '닉네임', leftIcon = 'back', isShowSaveBtn = false, saveBtntext, description = '닉네임은 30일에 1회 변경 가능합니다.', classNames }: IProps) => {
    const [nickName, setNickName] = useState<string>('');
    const inputRef = useRef<InputRef>(null);

    const onModalOpen = (modalOpen: boolean) => {
        if (modalOpen) {
            inputRef.current?.focus();
        } else {
            setNickName('')
        }
    }

    return <>
        <Modal afterOpenChange={onModalOpen} open={open} closeIcon={null} footer={null} style={{ padding: 0, margin: 0, maxWidth: '100%', top: 0 }} styles={{ content: { padding: 0, borderRadius: 0 }, body: { width: '100%', height: '100vh' } }}>
            <TopBar leftIcon={leftIcon === 'back' ? true : false} type='closeIcon' rightIcon={false} overOnClicks={{ left: () => setOpen(false) }} title={title} styles={{ title: { padding: '13px 0', lineHeight: '30px' } }} />
            <div style={{ paddingInline: '20px' }}>
                <div className={"body/b3 " + classNames?.description} style={{ marginBlock: '20px 24px' }}>
                    {description}
                </div>

                <NickNameCreateAndUpdateInput
                    nickName={nickName}
                    setNickName={setNickName}
                    setOpen={setOpen}
                    propsRefetch={propsRefetch}
                    propsInputRef={inputRef}
                    isShowSaveBtn={isShowSaveBtn}
                    classNames={classNames}
                    saveBtntext={saveBtntext} />
            </div>
        </Modal>
    </>
}

export default NickNameCreateAndUpdateModal;